import type { ReactNode } from "react";
import type { BreadcrumbItem } from "@/core/navigation/breadcrumb-trail";
import { Breadcrumb } from "@/components/Breadcrumb";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  breadcrumb?: BreadcrumbItem[];
}

export function PageHeader({ title, description, actions, breadcrumb }: PageHeaderProps) {
  return (
    <div className="ph-page-header mb-4">
      {breadcrumb && breadcrumb.length > 1 && <Breadcrumb items={breadcrumb} />}
      <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap">
        <div>
          <h2 className="h4 mb-1 fw-bold" style={{ color: "var(--ph-text)" }}>
            {title}
          </h2>
          {description && <p className="text-muted small mb-0">{description}</p>}
        </div>
        {actions}
      </div>
    </div>
  );
}
